import PropTypes from 'prop-types';

export const props = {
  params: PropTypes.shape({}),
  prefixForNumeric: PropTypes.string,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  size: PropTypes.string,
};

export const defaultProps = {
  params: {},
};
